import { z } from 'zod';

export const businessGoalAIGenerateSchema = z.object({
  current_revenue: z
    .union([z.string(), z.number()])
    .transform(val => {
      const num = typeof val === 'string' ? parseFloat(val) : val;
      return isNaN(num) ? undefined : num;
    })
    .refine(val => val === undefined || val >= 0, {
      message: 'Current revenue cannot be negative',
    })
    .optional(),
  growth_target: z
    .union([z.string(), z.number()])
    .transform(val => {
      const num = typeof val === 'string' ? parseFloat(val) : val;
      return isNaN(num) ? undefined : num;
    })
    .refine(val => val === undefined || (val >= 0 && val <= 100), {
      message: 'Growth target must be between 0 and 100',
    })
    .optional(),
  business_type: z.string().min(3, 'Business type must be at least 3 characters').optional().or(z.literal('')),
  market_size: z.string().optional().or(z.literal('')),
});

export type BusinessGoalAIGenerateFormData = z.infer<typeof businessGoalAIGenerateSchema>;
